import React, { Component } from 'react';
import { Table, Button, Alert, Spinner, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOn, faToggleOff, faSpinner,  faCheck, faUndo } from '@fortawesome/free-solid-svg-icons';
import PeriodoService from '../../services/PeriodoService';

export default class PeriodosList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      periodos: [],
      loading: true,
      message: '',
      error: '',
      updatingId: null
    };
  }

  componentDidMount() {
    this.cargarPeriodos();
  }

  cargarPeriodos = async () => {
    try {
      this.setState({ loading: true, message: '', error: '' });
      const response = await PeriodoService.getAll();
      // Ordenar los períodos por ID de menor a mayor
      const periodosOrdenados = [...response.data].sort((a, b) => a.id - b.id);
      this.setState({
        periodos: periodosOrdenados,
        loading: false
      });
    } catch (error) {
      console.error('Error al cargar períodos:', error);
      this.setState({
        error: 'Error al cargar los períodos',
        loading: false
      });
    }
  }

  togglePeriodo = async (periodo) => {
    const { id, estado } = periodo;
    const accion = estado ? 'Desactivar' : 'Activar';
    
    if (window.confirm(`¿Está seguro de ${accion} el ${periodo.descripcion}?`)) {
      try {
        this.setState({ updatingId: id });
        
        // // Si se está activando, primero desactivamos todos los demás
        // if (!activo) {
        //   const response = await PeriodoService.getAll();
        //   const periodos = response.data;
          
        //   // Desactivar todos los períodos activos
        //   const updates = periodos
        //     .filter(p => p.activo && p.id !== id)
        //     .map(p => PeriodoService.togglePeriodo(p.id, false));
          
        //   await Promise.all(updates);
        // }
        
        // Actualizamos el estado del período seleccionado
        await PeriodoService.togglePeriodo(id, !estado);
        
        // Recargamos la lista
        await this.cargarPeriodos();
        
        this.setState({
          message: `Período actualizado correctamente`,
          error: ''
        });
        
        // Notificar al componente padre para actualizar el período activo en el menú
        if (this.props.onPeriodoChange) {
          this.props.onPeriodoChange();
        }
      } catch (error) {
        console.error(`Error al ${accion} período:`, error);
        this.setState({
          error: `Error al ${accion} el período`,
          message: ''
        });
      } finally {
        this.setState({ updatingId: null });
      }
    }
  }

  render() {
    const { periodos, loading, message, error, updatingId } = this.state;

    return (
      <div className="container mt-4">
        <h2 className="mb-4">Gestión de Períodos Académicos</h2>
        
        {message && <Alert variant="success" onClose={() => this.setState({ message: '' })} dismissible>{message}</Alert>}
        {error && <Alert variant="danger" onClose={() => this.setState({ error: '' })} dismissible>{error}</Alert>}
        
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          </div>
        ) : (
          <Table striped bordered hover responsive className="table-hover">
            <thead className="table-dark">
              <tr>
                <th>Nombre</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {periodos.length > 0 ? (
                periodos.map((periodo) => (
                  <tr key={periodo.id} className={periodo.estado ? 'table-success' : ''}>
                    <td>{periodo.descripcion}</td>
                    <td>{new Date(periodo.fechaInicio).toLocaleDateString()}</td>
                    <td>{new Date(periodo.fechaFin).toLocaleDateString()}</td>
                    <td>
                      <Badge bg={periodo.estado ? 'success' : 'secondary'}>
                        {periodo.estado ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </td>
                    <td>
                      <Button 
                        variant={periodo.estado  ? 'outline-danger' : 'outline-success'} 
                        size="sm"
                        onClick={() => this.togglePeriodo(periodo)}
                        disabled={updatingId === periodo.id}
                        title={periodo.estado  ? 'Desactivar período' : 'Activar período'}
                      >
                        {updatingId === periodo.id ? (
                          <>
                            <FontAwesomeIcon icon={faSpinner} spin className="me-1" />
                            Procesando...
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={periodo.estado  ? faCheck : faCheck  } className="me-1" />
                            {periodo.estado  ? ' Desactivar' : ' Activar'}
                          </>
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">No hay períodos registrados</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>
    );
  }
}
